import type { RestangularService } from '../common/restangular.service'

import { app } from '../../app.module'

/**
 * ユーザー招待用のモーダル
 */
class UserInviteModalComponentCtrl {
  private groupId: number
  private userId: number
  private email: string
  private name: string
  private pictureUrl: string
  private isAdmin: boolean
  private mailStatus: string
  private checkedMail: string

  constructor(
    private $rootScope,
    private $mdDialog: {
      hide: Function
    },
    private RestangularService: RestangularService,
    private DialogService
  ) {
    this.isAdmin = false
    this.groupId = $rootScope.groupId
    this.mailStatus = 'pending'
  }

  /**
   * 入力したメールアドレスをチェック
   */
  public checkInvitationMail() {
    // メールがないまたは既にチェックされたメールの場合、リターン
    if (this.email === undefined || this.email === this.checkedMail) {
      return
    }
    this.checkedMail = this.email

    const endpoint = `/users/userByMail?email=${encodeURIComponent(this.email)}`

    this.RestangularService.request('GET', endpoint, null).then((result) => {
      const userInfo = result[0].data

      // メールがまだ登録されていない場合
      if (userInfo.length === 0) {
        this.userId = null
        this.name = null
        this.pictureUrl = null
        this.mailStatus = 'notExist'
        return
      }

      // 対象メールが選択しているグループのメンバーの場合、リターン
      if (
        userInfo[0].groupsId !== null &&
        userInfo[0].groupsId.split(',').indexOf(String(this.groupId)) > -1
      ) {
        this.userId = null
        this.mailStatus = 'pending'
        return
      }

      this.userId = userInfo[0].userId
      this.name = userInfo[0].name
      this.pictureUrl = userInfo[0].pictureUrl
      this.mailStatus = 'existed'
    })
  }

  /**
   * 入力したメールアドレスをチェック
   */
  public inviteUser() {
    const endpoint = '/group/user'

    this.RestangularService.request('POST', endpoint, {
      groupId: this.groupId,
      userId: this.userId,
      email: this.email,
      name: this.name,
      isAdmin: this.isAdmin ? 1 : 0,
      inviteUsername: this.$rootScope.userName,
      groupName: this.$rootScope.groupName,
    })
      .then(() => {
        // 保存成功の場合
        this.DialogService.showToast('ユーザーを追加しました。', 'success-toast')
        this.$mdDialog.hide({
          userId: this.userId,
          email: this.email,
          name: this.name,
          pictureUrl: this.pictureUrl,
          isAdmin: this.isAdmin,
        })
      })
      .catch(() => {
        // 保存失敗の場合
        this.DialogService.showToast('エラーが発生し、処理に失敗しました。', 'error-toast')
        this.$mdDialog.hide()
      })
  }
}

app.component('userInviteModal', {
  template: require('./user-invite-modal.pug')(),
  controller: UserInviteModalComponentCtrl,
})
